var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"page-pc",staticClass:"page-pc",class:_vm.rootClass,style:(_vm.rootStyle)},_vm._l((_vm.mergeState),function(v){return _c('renderer',{key:v.id,staticClass:"page-pc-child",style:(_vm.setStyle(v)),attrs:{"tpl":v}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=template&id=b4bdc92c&scoped=true&
// module id = 358
// module chunks = 0